export default "__VITE_ASSET__Cokn0WCV__"